import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router';
import { urlIsExternal } from 'helpers/ContentHelper';
import style from './SiteMap.css';

export const LABEL_SITEMAP = 'Sitemap';
export const LABEL_MAIN = 'Main';
export const LABEL_MOVIES = 'All Movies';
export const LABEL_SHOWS = 'All Shows';
export const LABEL_CHANNEL = 'All Channels';
export const LABEL_LEGAL = 'Legal';
export const LABEL_PERSONALITIES = 'All Personalities';

export const LABEL_ABOUT = 'About';
export const LABEL_CREDITS = 'Meet the Cast';
export const LABEL_EPISODES = 'Episodes';

export const TYPE_CLIPS_LANDING = 'clipLanding';
export const TYPE_SHOW_DETAIL = 'showDetail';
export const TYPE_MOVIE_DETAIL = 'movieDetail';
export const TYPE_CHANNEL = 'channel';
export const TYPE_PERSONALITY_DETAIL = 'personality';

export const filterSitemap = (siteMap, type) => {
  if (!siteMap) return [];
  let list;
  switch (type) {
    case TYPE_CHANNEL:
      list = _.sortBy(
        siteMap.filter(map => map.type === TYPE_CHANNEL),
        'title',
      );
      break;
    case TYPE_SHOW_DETAIL:
      list = _.sortBy(
        siteMap.filter(map => map.type === TYPE_SHOW_DETAIL),
        'title',
      );
      break;
    case TYPE_MOVIE_DETAIL:
      list = _.sortBy(
        siteMap.filter(map => map.type === TYPE_MOVIE_DETAIL),
        'title',
      );
      break;
    case TYPE_PERSONALITY_DETAIL:
      list = _.sortBy(
        siteMap.filter(map => map.type === TYPE_PERSONALITY_DETAIL),
        'title',
      );
      break;
    default:
      list = siteMap;
  }
  return list && list.length ? list : [];
};

const ARIA_LABELS = {
  'https://foxnews.com': 'Fox News',
  '/live-news/': 'Watch Fox News Plus',
};

const getCustomAriaLabel = url => (ARIA_LABELS[url] ? ARIA_LABELS[url] : null);

export const createLink = (url, text, isShowTitle = false, ariaLabel = null) => {
  const fontStyle = isShowTitle ? style.seriesListGroup : style.contentLink;

  const selectedAriaLabel = ariaLabel || getCustomAriaLabel(url);

  const otherProps = {};
  if (selectedAriaLabel) otherProps['aria-label'] = selectedAriaLabel;

  if (urlIsExternal(url)) {
    return (
      <a href={url} className={fontStyle} target="_blank" rel="noopener noreferrer" {...otherProps}>
        {text}
      </a>
    );
  }

  return (
    <Link to={url} className={fontStyle} onlyActiveOnIndex {...otherProps}>
      {text}
    </Link>
  );
};

export const createListLink = (url, text, ariaLabel) => (
  <li className={style.listGroupItem} key={url}>
    {createLink(url, text, false, ariaLabel)}
  </li>
);

export const extractLinks = markdown => {
  const mdReg = /[^!]\[.+?\]\(.+?\)/g;
  const textReg = /\[([^)]+)\]/;
  const linkReg = /\(([^)]+)\)/;
  const matches = markdown.match(mdReg);
  const links = [];

  _.forEach(matches, value => {
    const text = value.match(textReg)[1];
    const link = value.match(linkReg)[1];
    links.push({
      text,
      link,
    });
  });
  return links;
};
